import React from 'react';
import { useForm } from "react-hook-form";
import emailjs from "@emailjs/browser";

const ProjectForm = () => {
    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        mode: "onBlur"
    });

    const onSubmit = async (data) => {
        try {
            await emailjs.send('service_0sswgs8', 'template_tj0zu4g', data, 'i-8X0198e36XAW_oT');
            alert('Email sent successfully!');
            reset();
        } catch (error) {
            alert('Oops something went wrong');
            console.error('Error sending email:', error);
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row mb-n4">
                <div className="col-md-12 col-12 mb-4">
                    <input
                        type="text"
                        placeholder="Your Name *"
                        {...register("from_name", { required: 'Name is required' })}
                    />
                    {errors.from_name && <p className="form-error">{errors.from_name.message}</p>}
                </div>
                <div className="col-md-12 col-12 mb-4">
                    <input
                        type="email"
                        placeholder="Email *"
                        {...register("from_email", {
                            required: 'Email is required',
                            pattern: {
                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                message: "invalid email address"
                            }
                        })}
                    />
                    {errors.from_email && <p className="form-error">{errors.from_email.message}</p>}
                </div>
                <div className="col-12 mb-6">
                    <textarea
                        placeholder="Message"
                        {...register("message", { required: 'Message is required' })}
                    ></textarea>
                    {errors.message && <p className="form-error">{errors.message.message}</p>}
                </div>
                <div className="col-12 text-center mb-4">
                    <button type="submit" className="btn btn-brand-color btn-hover-secondary">Get a free consultation</button>
                </div>
            </div>
        </form>
    );
};

export default ProjectForm;
